export default __webpack_public_path__ + "static/media/bhot-tez.5ef798d2.jpg";